import React, { useEffect } from 'react';

import FullscreenLoader from '../components/FullscreenLoader';
import Layout from '../components/Layout';
import SuspenseRoute from './SuspenseRoute';
import { useAuth } from 'oidc-react';

interface IAuthRouteProps {
  children: React.ReactNode;
}

export default function AuthRoute({ children }: IAuthRouteProps) {
  const auth = useAuth();

  useEffect(() => {
    if (auth.isLoading) {
      return;
    }
    if (!auth.userData) {
      auth.signIn();
    }
  }, [auth, auth.userData]);

  if (auth.userData) {
    return (
      <SuspenseRoute>
        <Layout>{children}</Layout>
      </SuspenseRoute>
    );
  }

  return <FullscreenLoader />;
}
